import {Pill} from './pill';
import {Params} from '@angular/router';

export type OptionId = string;

export interface Option {
  id: string;
  name: string;
  subtitle?: string;
  href?: string;
  params?: Params;
  callback?: () => void;
  icon?: string;
  selected?: boolean;
  pill?: Pill;
}

export class OptionGroup {
  /**
   * This is just a convenient place for Angular templates to store whether
   * a menu should be open or not (instead of, e.g., having to have dedicated
   * component properties tracking whether a menu should be open)
   */
  menuActive: boolean = false;
  options: Option[] = [];

  constructor(options?: Option[]) {
    this.options = options || [];
  }

  changeSelected(id: string) {
    for (let option of this.options) {
      if (option.id === id) {
        option.selected = true;
      } else {
        option.selected = false;
      }
    }
  }

  getSelected(): Option[] {
    return this.options.filter(o => o.selected);
  }

  getUnselected(): Option[] {
    return this.options.filter(o => !o.selected);
  }
}

export class OptionGroupMultiSelect extends OptionGroup {
  private _initialSelection: Set<string> = new Set();
  canConfigure?: boolean; // Used for permission caching in multiselect

  select(id: string) {
    this.options.find(o => o.id === id).selected = true;
  }

  selectAll() {
    for (let option of this.options) {
      option.selected = true;
    }
  }

  deselect(id: string) {
    this.options.find(o => o.id === id).selected = false;
  }

  deselectAll() {
    for (let option of this.options) {
      option.selected = false;
    }
  }

  saveInitialSelection() {
    this._initialSelection = new Set(this.getSelected().map(o => o.id));
  }

  hasChanges(): boolean {
    const currentSelection = new Set(this.getSelected().map(o => o.id));
    return this._initialSelection.size !== currentSelection.size ||
      [...currentSelection].some(id => !this._initialSelection.has(id));
  }
}
